module.exports = __webpack_public_path__ + "static/patrickPic-3ab5805d7a983962d4df06e1786d65dc.png";